/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type appGoogleDrive_viewer = {
    readonly id: string;
    readonly company: {
        readonly id: string;
        readonly gdriveEnabled: boolean | null;
    } | null;
    readonly " $refType": "appGoogleDrive_viewer";
};
export type appGoogleDrive_viewer$data = appGoogleDrive_viewer;
export type appGoogleDrive_viewer$key = {
    readonly " $data"?: appGoogleDrive_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"appGoogleDrive_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appGoogleDrive_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gdriveEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'b14dec5a4da96499a92004fc0c33aab2';
export default node;
